// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"7db4e4fe","583":"cb0acda8","625":"cd6fbc4d","865":"8d3c9193","910":"598636eb"}[chunkId] + ".chunk.js";
};